// extracted by mini-css-extract-plugin
export default {"claim_landing_tabs_wrapper":"claimLandingTabs_claim_landing_tabs_wrapper__OU+Ra","claim_landing_tabs_container":"claimLandingTabs_claim_landing_tabs_container__EspGB"};